// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homePageWrapper {
    overflow: auto;
    height: 100vh;
}

.displayComponentHomePageContainerTop {
    padding-top: 5em;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 4em;
    background-color: var(--GrayBlue);
    margin: 0 auto;
}

.displayComponentHomePagetermsOfServcieDisplayContainer {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    z-index: 30000;
    backdrop-filter: blur(20px);
}

.displayComponentHomePageErrorMessage {
    display: flex;
    position: fixed;
    justify-content: center;
    font-size: 20px;
    background-color: var(--LiterGrayBlue);
    z-index: 300;
    top: 0;
    left: 0;
    margin: 0;
    border-radius: 5px;
    padding: 1em;
    contain: paint;
    left: 50%;
    transform: translate(-50%, 0%);
    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
}

.displayComponentHomePagetermsOfServcieDisplayText {
    position: absolute;
    right: 1em;
    top: 0em;
    font-size: 12px;
    opacity: 0.1;
}

.displayComponentHomePagetermsOfServcieDisplayText:hover {
    cursor: pointer;
}

.displayComponentHomePagePrivacyPolicyDisplayText {
    position: absolute;
    right: 1em;
    top: 1.5em;
    font-size: 12px;
    opacity: 0.1;
}

.displayComponentHomePagePrivacyPolicyDisplayText:hover {
    cursor: pointer;
}

/* WAVE display */
.displayComponentHomePageWaveContainer {
    contain: layout;
}

.displayComponentHomePageWaveDisplay {
    height: 40px;
    width: 100%;
    background: var(--GrayBlue);
    transform: scale(1, 1);
}

.displayComponentHomePageWaveDisplay:before {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100%;
    width: 100%;
    height: 300px;
    background-color: var(--DarkBlue);
    right: -25%;
    top: 20px;
}

.displayComponentHomePageWaveDisplay:after {
    content: "";
    display: block;
    position: absolute;
    border-radius: 100%;
    width: 100%;
    height: 300px;
    background-color: var(--GrayBlue);
    left: -25%;
    top: -240px;
    clip-path: ellipse(100% 15% at -15% 100%);
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/displayComponentHomePage/displayComponentHomePage.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,MAAM;IACN,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,SAAS;IACT,8BAA8B;IAC9B,uDAAuD;IACvD,oDAAoD;IACpD,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,iCAAiC;IACjC,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,iCAAiC;IACjC,UAAU;IACV,WAAW;IACX,yCAAyC;AAC7C","sourcesContent":[".homePageWrapper {\n    overflow: auto;\n    height: 100vh;\n}\n\n.displayComponentHomePageContainerTop {\n    padding-top: 5em;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 4em;\n    background-color: var(--GrayBlue);\n    margin: 0 auto;\n}\n\n.displayComponentHomePagetermsOfServcieDisplayContainer {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    z-index: 30000;\n    backdrop-filter: blur(20px);\n}\n\n.displayComponentHomePageErrorMessage {\n    display: flex;\n    position: fixed;\n    justify-content: center;\n    font-size: 20px;\n    background-color: var(--LiterGrayBlue);\n    z-index: 300;\n    top: 0;\n    left: 0;\n    margin: 0;\n    border-radius: 5px;\n    padding: 1em;\n    contain: paint;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    -webkit-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n}\n\n.displayComponentHomePagetermsOfServcieDisplayText {\n    position: absolute;\n    right: 1em;\n    top: 0em;\n    font-size: 12px;\n    opacity: 0.1;\n}\n\n.displayComponentHomePagetermsOfServcieDisplayText:hover {\n    cursor: pointer;\n}\n\n.displayComponentHomePagePrivacyPolicyDisplayText {\n    position: absolute;\n    right: 1em;\n    top: 1.5em;\n    font-size: 12px;\n    opacity: 0.1;\n}\n\n.displayComponentHomePagePrivacyPolicyDisplayText:hover {\n    cursor: pointer;\n}\n\n/* WAVE display */\n.displayComponentHomePageWaveContainer {\n    contain: layout;\n}\n\n.displayComponentHomePageWaveDisplay {\n    height: 40px;\n    width: 100%;\n    background: var(--GrayBlue);\n    transform: scale(1, 1);\n}\n\n.displayComponentHomePageWaveDisplay:before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    border-radius: 100%;\n    width: 100%;\n    height: 300px;\n    background-color: var(--DarkBlue);\n    right: -25%;\n    top: 20px;\n}\n\n.displayComponentHomePageWaveDisplay:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    border-radius: 100%;\n    width: 100%;\n    height: 300px;\n    background-color: var(--GrayBlue);\n    left: -25%;\n    top: -240px;\n    clip-path: ellipse(100% 15% at -15% 100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
